import { createSlice } from "@reduxjs/toolkit";

interface IDashboardState {
  transactionHistoryDataLoading: boolean;
  transactionHistoryData: any;
  creditHistoryDataLoading: boolean;
  creditHistoryData: any;
}

const initialState: IDashboardState = {
  transactionHistoryDataLoading: false,
  transactionHistoryData: null,
  creditHistoryDataLoading: false,
  creditHistoryData: null,
}

const publicSlice = createSlice({
  name: "public",
  initialState,
  reducers: {},
  extraReducers: (builder) => {

    // //get transaction history
    // builder.addCase(getTransactionHistoryAction.pending, (state) => {
    //   state.transactionHistoryDataLoading = true;
    //   state.transactionHistoryData = null;
    // });
    // builder.addCase(getTransactionHistoryAction.fulfilled, (state, action) => {
    //   state.transactionHistoryDataLoading = false;
    //   state.transactionHistoryData = action.payload.data;
    // });
    // builder.addCase(getTransactionHistoryAction.rejected, (state) => {
    //   state.transactionHistoryDataLoading = false;
    //   state.transactionHistoryData = null;
    // });
  }
})

export default publicSlice.reducer;